import { render, staticRenderFns } from "./narcoticReporting.vue?vue&type=template&id=054b516d"
import script from "./narcoticReporting.vue?vue&type=script&lang=js"
export * from "./narcoticReporting.vue?vue&type=script&lang=js"
import style1 from "./narcoticReporting.vue?vue&type=style&index=1&id=054b516d&prod&lang=css"
import style2 from "./narcoticReporting.vue?vue&type=style&index=2&id=054b516d&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports